module.exports = __webpack_public_path__ + "static/media/10.5b116321.svg";